import {X} from "react-feather";
import React from "react";

export const ModalDeleteRequestUpdate = ({id, onHandleToggle, handleDeleteAction}) => {
    
    const handleDelete = () => {
        handleDeleteAction(id);
        onHandleToggle();
    };

    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Delete request?
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>

            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div className="sl-text-md sl-font-normal sl-text-gray-700">
                        Are you sure you want to delete this request you sent? <br/>If you proceed, the request will be removed, and the vendor will not be informed about the requested update.
                    </div>
                </div>
            </div>

            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg ">
                        Cancel
                    </button>
                    <button onClick={handleDelete}
                            className="sl-btn sl-btn-destructive sl-btn-lg sl-rounded-lg ">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalDeleteRequestUpdate;
